var lastScrollLocation = 0
var mainTitle = $('#current-post-title').text()
var currentPost = 0

function processScroll(){

  var scrollLocation = $(window).scrollTop()

  if (scrollLocation > lastScrollLocation){
    if (window.matchMedia("(max-width: 1023px)").matches) {
      $('#navbar-fixed').fadeOut()
    }
    $('#article-info').fadeIn()
  } 
  else {
    if (window.matchMedia("(max-width: 1023px)").matches) {
      $('#navbar-fixed').fadeIn()
    }
    $('#article-info').fadeOut()
  }
  lastScrollLocation = scrollLocation;

  if(scrollLocation < $('#main_post').height()){
    scrollTopLimit = 0
    scrollBottomLimit = $('#main_post').height()
    currentPost = 0
  }
  else if(scrollLocation < $('#related_post_2').position().top - 2){
    scrollTopLimit = $('#related_post_1').position().top
    scrollBottomLimit = $('#related_post_1').height()
    currentPost = 1
  }
  else if(scrollLocation < $('#related_post_3').position().top - 2){
    scrollTopLimit = $('#related_post_2').position().top
    scrollBottomLimit = $('#related_post_2').height()
    currentPost = 2
  }
  else if(scrollLocation < $('#related_post_4').position().top - 2){
    scrollTopLimit = $('#related_post_3').position().top
    scrollBottomLimit = $('#related_post_3').height()
    currentPost = 3
  }
  else if(scrollLocation >= $('#related_post_4').position().top - 2){
    scrollTopLimit = $('#related_post_4').position().top
    scrollBottomLimit = $('#related_post_4').height()
    currentPost = 4
  }

  var scrollPercent = ((scrollLocation - scrollTopLimit) / scrollBottomLimit) * 100;
  
  document.getElementById("progress-bar-post").style.setProperty("--scrollAmount", scrollPercent+'%');

  if(scrollPercent > 80 && currentPost < 4){
    $("#icon-bar-post").addClass('right')
    $('.bar-post-state').text("Próxima matéria...")
    $('#current-post-title').text($('#related-'+(currentPost+1)).text())
  }
  else{
    $("#icon-bar-post").removeClass('right')
    $('.bar-post-state').text("Você está lendo...")
    currentPost == 0 ? $('#current-post-title').text(mainTitle) : $('#current-post-title').text($('#related-'+(currentPost)).text())
  } 

}

jQuery(document).ready(function($) {

  $(document).scroll(processScroll); 

  var coll = document.getElementsByClassName("collapsible");
  var icon = document.getElementById("icon-bar-post");
  var links = document.querySelectorAll(".bar-post-title.related");

  icon.addEventListener("click", function() {
    if($("#icon-bar-post").hasClass('right')){
      window.scrollTo(0, $('#related_post_'+(currentPost+1)).position().top);
      ClickNextPost();
    }
    else{
      ClickShowPosts();
      this.classList.toggle("up");
      var content = coll[0].nextElementSibling;
      if (content.style.maxHeight){
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      } 
    }
  });

  links.forEach(function(elem) {
    elem.addEventListener("click", function() {
      ClickPostChoose(this.id)
      icon.classList.toggle("up");
      var content = coll[0].nextElementSibling;
      if (content.style.maxHeight){
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      } 
    });
  });

});
